import { eventRoutes } from "./EventRoutes";

export const custom_event_handler = (event) => {

    let { name, payload, call, type } = event.detail;

    //console.log('custom_event_handler', event, name, payload, call, type);
    if(type in eventRoutes){
        eventRoutes[type](event);
    }
};